(() => {
  const initialize = () => {
    document.querySelectorAll('[data-mh-benefit-strip]:not([data-enhanced])').forEach((strip) => {
      const viewport = strip.querySelector('.mh-hp__benefit-viewport');
      const group = strip.querySelector('.mh-hp__benefit-group');
      const button = strip.querySelector('.mh-hp__benefit-toggle');
      if (!viewport || !group || !button) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = false, hovering = false, focused = false, position = 0, last = 0;
      strip.dataset.enhanced = 'true';
      const renderControl = () => {
        button.hidden = reduced.matches;
        button.textContent = paused ? 'Play' : 'Pause';
        button.setAttribute('aria-label', paused ? 'Start benefit scrolling' : 'Pause benefit scrolling');
      };
      const pauseForManual = () => { paused = true; position = viewport.scrollLeft; renderControl(); };
      button.addEventListener('click', () => { paused = !paused; position = viewport.scrollLeft; renderControl(); });
      strip.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') hovering = true; });
      strip.addEventListener('pointerleave', () => { hovering = false; });
      viewport.addEventListener('focusin', () => { focused = true; });
      viewport.addEventListener('focusout', (event) => { focused = viewport.contains(event.relatedTarget); });
      viewport.addEventListener('pointerdown', pauseForManual, { passive: true });
      viewport.addEventListener('wheel', pauseForManual, { passive: true });
      viewport.addEventListener('keydown', (event) => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) pauseForManual();
      });
      const motionChanged = () => { position = viewport.scrollLeft; renderControl(); };
      reduced.addEventListener('change', motionChanged);
      renderControl();
      const tick = (now) => {
        if (!strip.isConnected) { reduced.removeEventListener('change', motionChanged); return; }
        const elapsed = last ? Math.min(now - last, 60) : 0;
        last = now;
        if (!paused && !hovering && !focused && !reduced.matches && !document.hidden) {
          const cycle = group.getBoundingClientRect().width;
          if (cycle > 0 && viewport.scrollWidth > viewport.clientWidth) {
            position = (position + elapsed * 0.014) % cycle;
            viewport.scrollLeft = position;
          }
        } else { position = viewport.scrollLeft; }
        window.requestAnimationFrame(tick);
      };
      window.requestAnimationFrame(tick);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
